import { AxiosInstance } from 'axios';
import {
  ConfigResponse,
  IExamMasterCodeItem,
  NonExamMasterCodeItem,
  UpdateConfigRequest,
} from './model';
import { ROUTE } from './route';
import { axiosFactory } from '../client';

const baseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/configuration/api`;
const timeout = 5000;

export const configClient = axiosFactory(baseURL, timeout);

export const configTestClient = (configClient as unknown) as AxiosInstance;

export const getConfig = () => configClient.get<ConfigResponse>(ROUTE.GET_CONFIG);

export const postConfig = (csrfToken: string, data: UpdateConfigRequest[]) =>
  configClient.post<undefined>(csrfToken, ROUTE.UPDATE_CONFIG, data);

export const getIExamConfig = () => configClient.get<any>(ROUTE.GET_IEXAM_CONFIG);

export const postIExamConfig = (csrfToken: string, data: any) =>
  configClient.post<undefined>(csrfToken, ROUTE.UPDATE_IEXAM_CONFIG, data);

export const getIExamCountryCode = () =>
  configClient.get<IExamMasterCodeItem>(ROUTE.GET_IEXAM_COUNTRY_CODE, null, { timeout: 5000 });

export const getIExamBirthCountryCode = () =>
  configClient.get<NonExamMasterCodeItem[]>(ROUTE.GET_IEXAM_BIRTH_COUNTRY_CODE, null, {
    timeout: 20000,
  });
